// Kannada
const dict = {
  // Brand / common
  "Every Win, Securely Paid.": "ಪ್ರತಿ ಗೆಲುವಿಗೂ, ಸುರಕ್ಷಿತ ಪಾವತಿ.",
  "Loading Sara777": "Sara777 ಲೋಡ್ ಆಗುತ್ತಿದೆ",
  "App version {version}": "ಆ್ಯಪ್ ಆವೃತ್ತಿ {version}",
  "Language": "ಭಾಷೆ",
  "Home": "ಮುಖಪುಟ",
  "Account": "ಖಾತೆ",
  "Wallet": "ವಾಲೆಟ್",
  "History": "ಇತಿಹಾಸ",
  "All Bids": "ಎಲ್ಲಾ ಬಿಡ್‌ಗಳು",
  "Profile": "ಪ್ರೊಫೈಲ್",
  "My Profile": "ನನ್ನ ಪ್ರೊಫೈಲ್",
  "Open menu": "ಮೆನು ತೆರೆಯಿರಿ",
  "Close menu": "ಮೆನು ಮುಚ್ಚಿ",
  "Go back": "ಹಿಂದೆ ಹೋಗಿ",
  "Back": "ಹಿಂದೆ",
  "Close": "ಕ್ಲೋಸ್",
  "Open": "ಓಪನ್",
  "Submit": "ಸಲ್ಲಿಸಿ",
  "Cancel": "ರದ್ದುಮಾಡಿ",
  "Continue": "ಮುಂದುವರಿಯಿರಿ",
  "Update": "ಅಪ್‌ಡೇಟ್ ಮಾಡಿ",
  "Copy": "ನಕಲಿಸಿ",
  "Change": "ಬದಲಿಸಿ",
  "Refresh": "ರಿಫ್ರೆಶ್ ಮಾಡಿ",
  "Date": "ದಿನಾಂಕ",
  "Status": "ಸ್ಥಿತಿ",
  "Action": "ಕ್ರಿಯೆ",
  "Remark": "ಟಿಪ್ಪಣಿ",
  "Amount": "ಮೊತ್ತ",
  "Points": "ಪಾಯಿಂಟ್‌ಗಳು",
  "Bids": "ಬಿಡ್‌ಗಳು",
  "Session": "ಸೆಷನ್",
  "Pending": "ಬಾಕಿ ಇದೆ",
  "Failed": "ವಿಫಲವಾಗಿದೆ",
  "Success": "ಯಶಸ್ವಿ",
  "optional": "ಐಚ್ಛಿಕ",
  "Since {date}": "{date} ರಿಂದ",

  // Sidebar
  "Account Statement": "ಖಾತೆ ವಿವರ",
  "Game Rates": "ಆಟದ ದರಗಳು",
  "Terms & Conditions": "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
  "Video": "ವಿಡಿಯೋ",
  "Logout": "ಲಾಗ್ ಔಟ್",
  "Privacy Policy": "ಗೌಪ್ಯತಾ ನೀತಿ",

  // Login / sign-up / MPIN / OTP
  "Login": "ಲಾಗಿನ್",
  "Sign up": "ಸೈನ್ ಅಪ್ ಮಾಡಿ",
  "New here?": "ಹೊಸಬರೇ?",
  "Already have an account?": "ಈಗಾಗಲೇ ಖಾತೆ ಇದೆಯೇ?",
  "Have an account?": "ಖಾತೆ ಇದೆಯೇ?",
  "Enter Number": "ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
  "Enter your valid mobile number": "ನಿಮ್ಮ ಸರಿಯಾದ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
  "Mobile number": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
  "Mobile Number": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
  "Enter mobile number": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
  "4-digit MPIN": "4 ಅಂಕಿಯ MPIN",
  "Enter your 4-digit MPIN": "ನಿಮ್ಮ 4 ಅಂಕಿಯ MPIN ನಮೂದಿಸಿ",
  "Show MPIN": "MPIN ತೋರಿಸಿ",
  "Hide MPIN": "MPIN ಮರೆಮಾಡಿ",
  "Create Account": "ಖಾತೆ ರಚಿಸಿ",
  "Create your new account": "ನಿಮ್ಮ ಹೊಸ ಖಾತೆಯನ್ನು ರಚಿಸಿ",
  "Full name": "ಪೂರ್ಣ ಹೆಸರು",
  "Email address (optional)": "ಇಮೇಲ್ ವಿಳಾಸ (ಐಚ್ಛಿಕ)",
  "Create MPIN": "MPIN ರಚಿಸಿ",
  "Set a 4-digit PIN to log in quickly": "ತ್ವರಿತವಾಗಿ ಲಾಗಿನ್ ಆಗಲು 4 ಅಂಕಿಯ PIN ಹೊಂದಿಸಿ",
  "Enter MPIN": "MPIN ನಮೂದಿಸಿ",
  "Confirm MPIN": "MPIN ದೃಢೀಕರಿಸಿ",
  "{label} digit {n}": "{label} ಅಂಕಿ {n}",
  "Never share your MPIN with anyone.": "ನಿಮ್ಮ MPIN ಅನ್ನು ಯಾರೊಂದಿಗೂ ಹಂಚಿಕೊಳ್ಳಬೇಡಿ.",
  "MPINs match": "MPIN ಗಳು ಹೊಂದಿಕೆಯಾಗಿವೆ",
  "MPINs don't match. Try again.": "MPIN ಗಳು ಹೊಂದಿಕೆಯಾಗುತ್ತಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  "Enter your MPIN to login": "ಲಾಗಿನ್ ಆಗಲು ನಿಮ್ಮ MPIN ನಮೂದಿಸಿ",
  "Enter OTP": "OTP ನಮೂದಿಸಿ",
  "Verify your mobile number": "ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ಪರಿಶೀಲಿಸಿ",
  "Verify": "ಪರಿಶೀಲಿಸಿ",

  // Home
  "Add Money": "ಹಣ ಸೇರಿಸಿ",
  "Withdraw": "ಹಿಂಪಡೆಯಿರಿ",
  "Betting is Running Now": "ಬೆಟ್ಟಿಂಗ್ ಈಗ ನಡೆಯುತ್ತಿದೆ",
  "Betting is Closed for Today": "ಇಂದಿಗೆ ಬೆಟ್ಟಿಂಗ್ ಮುಚ್ಚಲಾಗಿದೆ",
  "Play {name}": "{name} ಆಡಿ",
  "{name} chart": "{name} ಚಾರ್ಟ್",
  "Chart Info": "ಚಾರ್ಟ್ ಮಾಹಿತಿ",
  "Contact Support": "ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
  "Jodi Chart": "ಜೋಡಿ ಚಾರ್ಟ್",
  "Pana Chart": "ಪಾನಾ ಚಾರ್ಟ್",
  "Past jodi results": "ಹಿಂದಿನ ಜೋಡಿ ಫಲಿತಾಂಶಗಳು",
  "Past panna results": "ಹಿಂದಿನ ಪಾನಾ ಫಲಿತಾಂಶಗಳು",
  "Call Now": "ಈಗ ಕರೆ ಮಾಡಿ",
  "Talk to our support team": "ನಮ್ಮ ಬೆಂಬಲ ತಂಡದೊಂದಿಗೆ ಮಾತನಾಡಿ",
  "WhatsApp": "ವಾಟ್ಸಾಪ್",
  "Chat with us on WhatsApp": "ವಾಟ್ಸಾಪ್‌ನಲ್ಲಿ ನಮ್ಮೊಂದಿಗೆ ಚಾಟ್ ಮಾಡಿ",

  // Game types
  "Select a game type to play": "ಆಡಲು ಆಟದ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
  "Single Digit": "ಸಿಂಗಲ್ ಡಿಜಿಟ್",
  "Single Digit Bulk": "ಸಿಂಗಲ್ ಡಿಜಿಟ್ ಬಲ್ಕ್",
  "Jodi Digit": "ಜೋಡಿ ಡಿಜಿಟ್",
  "Jodi Digit Bulk": "ಜೋಡಿ ಡಿಜಿಟ್ ಬಲ್ಕ್",
  "Single Pana": "ಸಿಂಗಲ್ ಪಾನಾ",
  "Single Pana Bulk": "ಸಿಂಗಲ್ ಪಾನಾ ಬಲ್ಕ್",
  "Double Pana": "ಡಬಲ್ ಪಾನಾ",
  "Double Pana Bulk": "ಡಬಲ್ ಪಾನಾ ಬಲ್ಕ್",
  "Triple Pana": "ಟ್ರಿಪಲ್ ಪಾನಾ",
  "Triple Pana Bulk": "ಟ್ರಿಪಲ್ ಪಾನಾ ಬಲ್ಕ್",
  "Half Sangam": "ಹಾಫ್ ಸಂಗಮ್",
  "Full Sangam": "ಫುಲ್ ಸಂಗಮ್",
  "Jodi": "ಜೋಡಿ",
  "Single Panna": "ಸಿಂಗಲ್ ಪಾನಾ",
  "Double Panna": "ಡಬಲ್ ಪಾನಾ",
  "Triple Panna": "ಟ್ರಿಪಲ್ ಪಾನಾ",
  "Tripple Panna": "ಟ್ರಿಪಲ್ ಪಾನಾ",

  // Playing
  "Enter points": "ಪಾಯಿಂಟ್‌ಗಳನ್ನು ನಮೂದಿಸಿ",
  "Enter {label}": "{label} ನಮೂದಿಸಿ",
  "Add Bid": "ಬಿಡ್ ಸೇರಿಸಿ",
  "Submit Bid": "ಬಿಡ್ ಸಲ್ಲಿಸಿ",
  "Pana": "ಪಾನಾ",
  "Digits": "ಅಂಕಿಗಳು",
  "Open Pana": "ಓಪನ್ ಪಾನಾ",
  "Close Pana": "ಕ್ಲೋಸ್ ಪಾನಾ",
  "Open Digit": "ಓಪನ್ ಡಿಜಿಟ್",
  "Close Digit": "ಕ್ಲೋಸ್ ಡಿಜಿಟ್",
  "No bids added yet": "ಇನ್ನೂ ಯಾವುದೇ ಬಿಡ್ ಸೇರಿಸಿಲ್ಲ",
  "Remove bid {number}": "ಬಿಡ್ {number} ತೆಗೆದುಹಾಕಿ",
  "Bid status": "ಬಿಡ್ ಸ್ಥಿತಿ",
  "Note: Bid once played will not be cancelled": "ಗಮನಿಸಿ: ಒಮ್ಮೆ ಹಾಕಿದ ಬಿಡ್ ರದ್ದಾಗುವುದಿಲ್ಲ",
  "HOLD": "ಹೋಲ್ಡ್",
  "LOADING...": "ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
  "Failed !!": "ವಿಫಲವಾಗಿದೆ !!",

  // Bids / history
  "Transaction ID": "ವಹಿವಾಟು ID",
  "Placed": "ಹಾಕಲಾಗಿದೆ",
  "No bid history found.": "ಬಿಡ್ ಇತಿಹಾಸ ಕಂಡುಬಂದಿಲ್ಲ.",
  "Balance": "ಬ್ಯಾಲೆನ್ಸ್",
  "No transactions yet": "ಇನ್ನೂ ಯಾವುದೇ ವಹಿವಾಟುಗಳಿಲ್ಲ",
  "Deposit": "ಠೇವಣಿ",
  "No history found.": "ಇತಿಹಾಸ ಕಂಡುಬಂದಿಲ್ಲ.",
  "In Process": "ಪ್ರಕ್ರಿಯೆಯಲ್ಲಿದೆ",
  "Declined": "ತಿರಸ್ಕರಿಸಲಾಗಿದೆ",
  "User Withdrawal / deposit History": "ಹಿಂಪಡೆಯುವಿಕೆ / ಠೇವಣಿ ಇತಿಹಾಸ",

  // Charts
  "Bottom": "ಕೆಳಗೆ",
  "Back to top": "ಮೇಲಕ್ಕೆ ಹೋಗಿ",
  "Mon": "ಸೋಮ",
  "Tue": "ಮಂಗಳ",
  "Wed": "ಬುಧ",
  "Thu": "ಗುರು",
  "Fri": "ಶುಕ್ರ",
  "Sat": "ಶನಿ",
  "Sun": "ಭಾನು",

  // Rates / how to play
  "Main game win ratio for all bids": "ಎಲ್ಲಾ ಬಿಡ್‌ಗಳಿಗೆ ಮುಖ್ಯ ಆಟದ ಗೆಲುವಿನ ಅನುಪಾತ",
  "{min} KA {max}": "{min} ಕ್ಕೆ {max}",
  "How To Play": "ಹೇಗೆ ಆಡುವುದು",
  "Download our application from Google Play Store or from our official website.": "ನಮ್ಮ ಆ್ಯಪ್ ಅನ್ನು Google Play Store ಅಥವಾ ನಮ್ಮ ಅಧಿಕೃತ ವೆಬ್‌ಸೈಟ್‌ನಿಂದ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ.",
  "Register with your Mobile Number, Email ID, and User Name on our platform.": "ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ, ಇಮೇಲ್ ID ಮತ್ತು ಬಳಕೆದಾರ ಹೆಸರಿನೊಂದಿಗೆ ನಮ್ಮ ವೇದಿಕೆಯಲ್ಲಿ ನೋಂದಾಯಿಸಿ.",
  "Login to the application using your Mobile Number and MPIN.": "ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಮತ್ತು MPIN ಬಳಸಿ ಆ್ಯಪ್‌ಗೆ ಲಾಗಿನ್ ಆಗಿ.",
  "Select the Game type, choose your favourite number, and start to play the game.": "ಆಟದ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆಮಾಡಿ, ನಿಮ್ಮ ನೆಚ್ಚಿನ ಸಂಖ್ಯೆಯನ್ನು ಆರಿಸಿ ಮತ್ತು ಆಡಲು ಪ್ರಾರಂಭಿಸಿ.",
  "Get a chance to win up to 10 Lac Points.": "10 ಲಕ್ಷ ಪಾಯಿಂಟ್‌ಗಳವರೆಗೆ ಗೆಲ್ಲುವ ಅವಕಾಶ ಪಡೆಯಿರಿ.",

  // Wallet
  "Add Fund": "ಫಂಡ್ ಸೇರಿಸಿ",
  "Instant deposit via UPI / QR Code": "UPI / QR ಕೋಡ್ ಮೂಲಕ ತಕ್ಷಣದ ಠೇವಣಿ",
  "Manual Deposit": "ಮ್ಯಾನುಯಲ್ ಠೇವಣಿ",
  "Upload your payment screenshot": "ನಿಮ್ಮ ಪಾವತಿಯ ಸ್ಕ್ರೀನ್‌ಶಾಟ್ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
  "Withdraw Fund": "ಫಂಡ್ ಹಿಂಪಡೆಯಿರಿ",
  "Fast and secure withdrawal to bank": "ಬ್ಯಾಂಕ್‌ಗೆ ವೇಗವಾದ ಮತ್ತು ಸುರಕ್ಷಿತ ಹಿಂಪಡೆಯುವಿಕೆ",
  "Deposit & Withdraw History": "ಠೇವಣಿ ಮತ್ತು ಹಿಂಪಡೆಯುವಿಕೆ ಇತಿಹಾಸ",
  "Check your past transactions statement": "ನಿಮ್ಮ ಹಿಂದಿನ ವಹಿವಾಟುಗಳ ವಿವರ ನೋಡಿ",
  "Add Bank Details": "ಬ್ಯಾಂಕ್ ವಿವರಗಳನ್ನು ಸೇರಿಸಿ",
  "Update bank account for instant payouts": "ತಕ್ಷಣದ ಪಾವತಿಗಾಗಿ ಬ್ಯಾಂಕ್ ಖಾತೆಯನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಿ",
  "Total Wallet Balance": "ಒಟ್ಟು ವಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್",
  "Pay": "ಪಾವತಿಸಿ",
  "Minimum deposit limit is {amount}.": "ಕನಿಷ್ಠ ಠೇವಣಿ ಮಿತಿ {amount}.",
  "Enter withdraw points": "ಹಿಂಪಡೆಯುವ ಪಾಯಿಂಟ್‌ಗಳನ್ನು ನಮೂದಿಸಿ",
  "Amount is sent to your saved bank account.": "ಮೊತ್ತವನ್ನು ನೀವು ಉಳಿಸಿದ ಬ್ಯಾಂಕ್ ಖಾತೆಗೆ ಕಳುಹಿಸಲಾಗುತ್ತದೆ.",
  "Update bank details": "ಬ್ಯಾಂಕ್ ವಿವರಗಳನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಿ",
  "Pay to the UPI ID below, then enter the UTR number and upload the payment screenshot.": "ಕೆಳಗಿನ UPI ID ಗೆ ಪಾವತಿಸಿ, ನಂತರ UTR ಸಂಖ್ಯೆ ನಮೂದಿಸಿ ಮತ್ತು ಪಾವತಿಯ ಸ್ಕ್ರೀನ್‌ಶಾಟ್ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.",
  "Enter amount": "ಮೊತ್ತ ನಮೂದಿಸಿ",
  "Pay to UPI ID": "ಈ UPI ID ಗೆ ಪಾವತಿಸಿ",
  "UTR Number": "UTR ಸಂಖ್ಯೆ",
  "Enter 12-digit UTR number": "12 ಅಂಕಿಯ UTR ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
  "Payment Screenshot": "ಪಾವತಿ ಸ್ಕ್ರೀನ್‌ಶಾಟ್",
  "Tap to upload screenshot": "ಸ್ಕ್ರೀನ್‌ಶಾಟ್ ಅಪ್‌ಲೋಡ್ ಮಾಡಲು ಟ್ಯಾಪ್ ಮಾಡಿ",
  "Tap to change": "ಬದಲಿಸಲು ಟ್ಯಾಪ್ ಮಾಡಿ",
  "PNG or JPG": "PNG ಅಥವಾ JPG",
  "Bank Details": "ಬ್ಯಾಂಕ್ ವಿವರಗಳು",
  "IFSC Code": "IFSC ಕೋಡ್",
  "Account number": "ಖಾತೆ ಸಂಖ್ಯೆ",
  "Bank name": "ಬ್ಯಾಂಕ್ ಹೆಸರು",
  "Account holder name": "ಖಾತೆದಾರರ ಹೆಸರು",
  "Google Pay number": "Google Pay ಸಂಖ್ಯೆ",
  "PhonePe number": "PhonePe ಸಂಖ್ಯೆ",
  "Paytm number": "Paytm ಸಂಖ್ಯೆ",

  // Profile
  "Edit profile": "ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಿ",
  "Joined since": "ಸೇರಿದ ದಿನಾಂಕ",
  "Phone": "ಫೋನ್",
  "Wallet Balance": "ವಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್",
  "Update User Information": "ಬಳಕೆದಾರರ ಮಾಹಿತಿಯನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಿ",
  "Name": "ಹೆಸರು",
  "Email": "ಇಮೇಲ್",
  "PhonePe": "PhonePe",
  "Google Pay": "Google Pay",
  "Paytm": "Paytm",
  "Name is required.": "ಹೆಸರು ಅಗತ್ಯವಿದೆ.",
  "Email is required.": "ಇಮೇಲ್ ಅಗತ್ಯವಿದೆ.",
  "Email is invalid.": "ಇಮೇಲ್ ಸರಿಯಾಗಿಲ್ಲ.",
  "PhonePe number must be 10 digits.": "PhonePe ಸಂಖ್ಯೆ 10 ಅಂಕಿಗಳಾಗಿರಬೇಕು.",
  "Paytm number must be 10 digits.": "Paytm ಸಂಖ್ಯೆ 10 ಅಂಕಿಗಳಾಗಿರಬೇಕು.",
  "Google Pay number must be 10 digits.": "Google Pay ಸಂಖ್ಯೆ 10 ಅಂಕಿಗಳಾಗಿರಬೇಕು.",

  // Pop-up messages
  "Enter User name !!": "ಬಳಕೆದಾರ ಹೆಸರು ನಮೂದಿಸಿ !!",
  "Enter Valid mobile number !!": "ಸರಿಯಾದ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ !!",
  "Enter Valid email address !!": "ಸರಿಯಾದ ಇಮೇಲ್ ವಿಳಾಸ ನಮೂದಿಸಿ !!",
  "Enter your 4-digit MPIN !!": "ನಿಮ್ಮ 4 ಅಂಕಿಯ MPIN ನಮೂದಿಸಿ !!",
  "Only 4 digit allow !!": "4 ಅಂಕಿಗಳಿಗೆ ಮಾತ್ರ ಅನುಮತಿ !!",
  "Mpin does not match with confirm Mpin.": "MPIN ಮತ್ತು ದೃಢೀಕರಣ MPIN ಹೊಂದಿಕೆಯಾಗುತ್ತಿಲ್ಲ.",
  "This number is already registered. Please login.": "ಈ ಸಂಖ್ಯೆ ಈಗಾಗಲೇ ನೋಂದಾಯಿತವಾಗಿದೆ. ದಯವಿಟ್ಟು ಲಾಗಿನ್ ಆಗಿ.",
  "This number is not registered. Please create your account.": "ಈ ಸಂಖ್ಯೆ ನೋಂದಾಯಿತವಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಖಾತೆಯನ್ನು ರಚಿಸಿ.",
  "Unable to sign in. Please try again.": "ಲಾಗಿನ್ ಆಗಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  "Unable to continue. Please try again.": "ಮುಂದುವರಿಯಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  "Unable to create account. Please try again.": "ಖಾತೆ ರಚಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  "Api Error": "ಸರ್ವರ್ ದೋಷ",
  "Something went wrong. Please try again.": "ಏನೋ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  "This Market Betting Is Closed For Today.": "ಈ ಮಾರುಕಟ್ಟೆಯಲ್ಲಿ ಇಂದಿಗೆ ಬೆಟ್ಟಿಂಗ್ ಮುಚ್ಚಲಾಗಿದೆ.",
  "Please Enter minimum 10 Points.": "ದಯವಿಟ್ಟು ಕನಿಷ್ಠ 10 ಪಾಯಿಂಟ್‌ಗಳನ್ನು ನಮೂದಿಸಿ.",
  "Please Enter Points for Betting.": "ದಯವಿಟ್ಟು ಬೆಟ್ಟಿಂಗ್‌ಗಾಗಿ ಪಾಯಿಂಟ್‌ಗಳನ್ನು ನಮೂದಿಸಿ.",
  "Please Select Bids for Betting.": "ದಯವಿಟ್ಟು ಬೆಟ್ಟಿಂಗ್‌ಗಾಗಿ ಬಿಡ್‌ಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
  "Please enter a valid Number.": "ದಯವಿಟ್ಟು ಸರಿಯಾದ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ.",
  "Please Enter Amount first.": "ದಯವಿಟ್ಟು ಮೊದಲು ಮೊತ್ತ ನಮೂದಿಸಿ.",
  "Please Enter UTR first.": "ದಯವಿಟ್ಟು ಮೊದಲು UTR ನಮೂದಿಸಿ.",
  "Please select a valid image file.": "ದಯವಿಟ್ಟು ಸರಿಯಾದ ಚಿತ್ರ ಫೈಲ್ ಆಯ್ಕೆಮಾಡಿ.",
  "UPI copied to clipboard!": "UPI ಕ್ಲಿಪ್‌ಬೋರ್ಡ್‌ಗೆ ನಕಲಿಸಲಾಗಿದೆ!",
  "Profile Updated Successfully.": "ಪ್ರೊಫೈಲ್ ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಡೇಟ್ ಆಗಿದೆ.",
};

export default dict;
